module.exports = __webpack_public_path__ + "./fonts/417bce589dbd2357203c07852835a4c5.ttf";